import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { PageHeader } from "@/components/primitives";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ArrowLeft, Mail } from "lucide-react";

export default function AdminContacts() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.is_admin) {
      api.get("/admin/contact-messages")
        .then((r) => setItems(r.data))
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, [user]);

  if (user === null) return null;
  if (!user || !user.is_admin) return <Navigate to="/home" replace />;

  return (
    <div data-testid="admin-contacts-page">
      <div className="pt-6">
        <Link to="/admin" className="chip" data-testid="admin-contacts-back">
          <ArrowLeft size={14} /> Admin
        </Link>
      </div>
      <PageHeader kicker="Admin · Letters" title="Notes to the patch" subtitle="Sent via the Contact form" />

      {loading ? (
        <p className="text-center font-display italic text-ink-soft py-12">Opening the post bag...</p>
      ) : items.length === 0 ? (
        <p className="text-center font-display italic text-ink-soft py-12" data-testid="admin-contacts-empty">
          No letters yet.
        </p>
      ) : (
        <div className="space-y-3" data-testid="admin-contacts-list">
          {items.map((m) => (
            <article key={m.id} className="h-card p-4" data-testid={`admin-contact-${m.id}`}>
              <div className="flex items-baseline justify-between gap-3">
                <div>
                  <div className="font-display text-xl text-sage-dark">{m.name}</div>
                  <a href={`mailto:${m.email}`} className="text-ink-soft text-sm hover:underline">{m.email}</a>
                </div>
                <div className="text-xs text-ink-soft whitespace-nowrap">
                  {new Date(m.created_at).toLocaleDateString("en-NZ", { day: "2-digit", month: "short", year: "numeric" })}
                </div>
              </div>
              <p className="mt-2 font-display italic text-ink leading-relaxed whitespace-pre-wrap">{m.message}</p>
              <a
                href={`mailto:${m.email}?subject=Re:%20your%20note%20to%20Heritage%20Dahlias`}
                className="chip mt-3 inline-flex"
              >
                <Mail size={13} /> Reply
              </a>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
